//IMPORTANT: If you add or remove icons here, make sure to update the help text in bulk-import-trigger-drawer.tsx (That's the Template that is downloaded in the Trigger Bulk Import Drawer)
export const iconOptions = [
  { value: "arrow-down", label: "Arrow Down", icon: "" },
  { value: "arrow-up", label: "Arrow Up", icon: "" },
  { value: "ban", label: "Ban", icon: "" },
  { value: "band-aid", label: "Band Aid", icon: "" },
  { value: "battery-full", label: "Battery Full", icon: "" },
  { value: "battery-low", label: "Battery Low", icon: "" },
  { value: "bell", label: "Bell", icon: "" },
  { value: "bike", label: "Bike", icon: "" },
  { value: "bolt", label: "Bolt", icon: "" },
  { value: "bookmark", label: "Bookmark", icon: "" },
    { value: "chess-king", label: "Chess King", icon: "" },
  { value: "chess-queen", label: "Chess Queen", icon: "" },
  { value: "clock", label: "Clock", icon: "" },
  { value: "crystal-ball", label: "Crystal Ball", icon: "" },
  { value: "fast-backward", label: "Fast Backward", icon: "" },
  { value: "fast-forward", label: "Fast Forward", icon: "" },
  { value: "flag", label: "Flag", icon: "" },
  { value: "flame", label: "Flame", icon: "" },
  { value: "gear", label: "Gear", icon: "" },
  { value: "grid", label: "Grid", icon: "" },
  { value: "heart", label: "Heart", icon: "" },
  { value: "heart-pulse", label: "Heart Pulse", icon: "" },
  { value: "lightbulb", label: "Lightbulb", icon: "" },
  { value: "map-marker", label: "Map Marker", icon: "" },
  { value: "medal", label: "Medal", icon: "" },
  { value: "minus", label: "Minus", icon: "" },
  { value: "movie", label: "Movie", icon: "" },
  { value: "plus", label: "Plus", icon: "" },
  { value: "rocket", label: "Rocket", icon: "" },
  { value: "run", label: "Run", icon: "" },
  { value: "smile", label: "Smile", icon: "" },
  { value: "sparkles", label: "Sparkles", icon: "" },
  { value: "star", label: "Star", icon: "" },
  { value: "swap", label: "Swap", icon: "" },
  { value: "swim", label: "Swim", icon: "" },
  { value: "thumbs-up", label: "Thumbs Up", icon: "" },
  { value: "trophy", label: "Trophy", icon: "" },
  { value: "umbrella", label: "Umbrella", icon: "" },
  { value: "user", label: "User", icon: "" },
  { value: "users", label: "Users", icon: "" },
] as const;

// Export array of valid icon values for validation
export const validIconValues = iconOptions.map((option) => option.value);
